import gql from "graphql-tag";

export const UPDATE_BACKLOG = gql`
  mutation updateBacklog($input: updateBacklogInput) {
    updateBacklog(input: $input) {
      _id
    }
  }
`;
